var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import labelBadgeStyles from '@cof/fs-label-badge-core/lib/label-badge.lit.min.js';
import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * The web component implementation of the Financial Services label badge component
 *
 * ## Installation
 *
 * ```bash
 * npm install @cof/fs-label-badge-wc
 * ```
 *
 * ## Usage
 *
 * To import the side-effectful registration of `<fs-label-badge>`, call
 *
 * ```javascript
 * import '@cof/fs-label-badge-wc/fs-label-badge';
 * ```
 *
 * To import the `FsLabelBadge class as either a base class or to self-register the custom element, use
 *
 * ```javascript
 * import { FsLabelBadge } from '@cof/fs-label-badge';
 * ```
 *
 * ## Example
 *
 * ```html
 * <fs-label-badge
 *   emphasis="high"
 *   variant="critical"
 * >
 *   Label badge
 * </fs-label-badge>
 * ```
 *
 * @element fs-label-badge
 * @slot - The label badge's contents
 * ```
 */
export class FsLabelBadge extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * When compact is set to true, the label badge
         * will use compact styles
         */
        this.compact = false;
        /**
         * The emphasis to attach to the label badge, possible values
         * are 'high', 'medium' and 'low'
         */
        this.emphasis = 'high';
        /**
         * The variant of the label badge to display to the user
         * possible values are 'info', 'positive', 'warning', 'critical', 'neutral', 'inverted' and 'overlay'.
         */
        this.variant = 'info';
    }
    static get styles() {
        return [
            labelBadgeStyles,
            css `
      :host {
        display: inline-block;
      }
    `
        ];
    }
    render() {
        return html `
      <div class="fs-label-badge fs-label-badge--${this.variant} ${this.compact ? 'fs-label-badge--compact' : ''} fs-label-badge--${this.emphasis}-emphasis">
        <slot></slot>
      </div>
    `;
    }
}
/** The element's canonical name for use with safe define */
FsLabelBadge.canonicalName = 'label-badge';
__decorate([
    property({ type: Boolean, reflect: true })
], FsLabelBadge.prototype, "compact", void 0);
__decorate([
    property({ type: String, reflect: true })
], FsLabelBadge.prototype, "emphasis", void 0);
__decorate([
    property({ type: String, reflect: true })
], FsLabelBadge.prototype, "variant", void 0);
//# sourceMappingURL=LabelBadge.js.map